import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Config from '../../commons/config/Config.js';

const EXTENSIONES_IMAGEN = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

const esImagen = (adjunto) => EXTENSIONES_IMAGEN.indexOf(String(adjunto.extension || '').toLowerCase()) !== -1;

const descargarBlob = (adjuntoId) =>
	axios
		.get(Config.get('apiUrlBase') + '/adjuntos/files/' + adjuntoId, {
			headers: { 'Authorization-Token': localStorage.getItem('token') },
			responseType: 'blob',
		})
		.then((respuesta) => URL.createObjectURL(respuesta.data));

const SolicitudAdjuntosLista = ({ adjuntos }) => {
	const [miniaturas, setMiniaturas] = useState({});

	useEffect(() => {
		let vigente = true;
		const urls = [];
		setMiniaturas({});

		adjuntos.filter(esImagen).forEach((adjunto) => {
			descargarBlob(adjunto.id)
				.then((url) => {
					urls.push(url);
					if (vigente) setMiniaturas((actuales) => Object.assign({}, actuales, { [adjunto.id]: url }));
				})
				.catch(() => {});
		});

		return () => {
			vigente = false;
			urls.forEach((url) => URL.revokeObjectURL(url));
		};
	}, [adjuntos.map((adjunto) => adjunto.id).join(',')]);

	const abrir = (adjunto) => {
		if (miniaturas[adjunto.id]) {
			window.open(miniaturas[adjunto.id]);
			return;
		}
		descargarBlob(adjunto.id)
			.then((url) => window.open(url))
			.catch(() => {});
	};

	return (
		<div className="d-flex flex-wrap">
			{adjuntos.map((adjunto) => (
				<button
					key={adjunto.id}
					type="button"
					className="btn btn-link p-1 m-1 text-center"
					style={{ width: 170 }}
					onClick={() => abrir(adjunto)}
				>
					{esImagen(adjunto) && miniaturas[adjunto.id] ? (
						<img src={miniaturas[adjunto.id]} alt={adjunto.nombre} style={{ width: 160, height: 120, objectFit: 'cover' }} />
					) : (
						<i className="la la-file-o" style={{ fontSize: 60 }}></i>
					)}
					<div className="text-truncate" style={{ fontSize: 12 }}>{adjunto.nombre}</div>
				</button>
			))}
		</div>
	);
};

export default SolicitudAdjuntosLista;
